import messages from './messages';

export { default } from './main';
export const addFlagLabel = messages.addFlag;
export const removeFlagLabel = messages.removeFlag;

export { default as FlagButtonItem } from './button-item';
